import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventBiService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    onBiComponentButtonClick() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventBiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventBiService_Factory() { return new EventBiService(); }, token: EventBiService, providedIn: "root" });
